// Week 6 / Day 5 — Проект недели: health dashboard + наблюдение пульса / Week Project + Pulse Observation
// Solid Grade 6 math + RU Grade 3–4 + safe practical pulse observation with parent.

export const maxWeek6Day5 = {
  id: 'max-week-6-day-5',
  studentId: 'max',
  weekId: 'week-6',
  dayId: 'day-5',
  title: 'Проект недели: health dashboard и наблюдение пульса / Week Project: Health Dashboard and Pulse Observation',
  shortTitle: 'Health dashboard / Health Dashboard',
  theme:
    'Итог недели: собрать данные сна, воды, активности и наблюдать пульс до и после движения. / Week wrap-up: gather sleep, water, activity data and observe pulse before/after movement.',
  estimatedTimeLabel: 'Онлайн: 30–40 мин. Полный день: 90–110 мин. / Online: 30–40 min. Full day: 90–110 min.',
  nimnyIntro:
    'Нимни ведёт Макса через health dashboard недели и безопасное наблюдение пульса до и после движения. / Nimny leads Max through the week health dashboard and a safe pulse observation before/after movement.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: пульс в минуту, процент роста, процент от прироста, среднее/размах, процент привычек с округлением (Grade 6). / bpm, growth %, % of change, mean/range, percent with ceiling.',
    'Слой 2. Русский / Layer 2. Russian: части речи и исправление ошибок.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о наблюдении тела + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: рассуждение о пульсе и восстановлении.',
    'Слой 5. Практика: health dashboard + наблюдение пульса. / Practical: health dashboard + pulse observation.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 5/9.'
  ],
  vocabulary: [
    { term: 'пульс / pulse', definition: 'удары сердца в минуту / heart beats per minute' },
    { term: 'наблюдение / observation', definition: 'что я вижу и записываю / what I see and record' },
    { term: 'восстановление / recovery', definition: 'возвращение к спокойному состоянию / return to a calm state' },
    { term: 'привычка / habit', definition: 'повторяющееся действие / a repeated action' },
    { term: 'dashboard / dashboard', definition: 'таблица итогов недели / a table with weekly totals' },
    { term: 'вывод / conclusion', definition: 'что я понял из данных / what I understood from data' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Пульс в минуту / Pulse per minute',
      prompt: 'До: 38 ударов за 30 секунд. После: 62 удара за 30 секунд. Найди пульс в уд/мин. / Convert 30-second counts to bpm.',
      helper: 'Умножь на 2. / Multiply by 2.',
      answer: '76 и 124 уд/мин. / 76 and 124 bpm.', unit: 'уд/мин / bpm' },
    { id: 'q2', type: 'math', title: 'Рост и процент роста пульса / Pulse growth',
      prompt: 'Пульс вырос с 76 до 124 уд/мин. На сколько ударов? На сколько процентов? / Increase and percent.',
      helper: '(124 − 76) ÷ 76. / Change divided by original.',
      answer: '+48 уд; ≈ 63.2%. / +48 bpm; ~63.2%.', unit: '%' },
    { id: 'q3', type: 'math', title: 'Восстановление после отдыха / Recovery',
      prompt: 'После отдыха пульс снизился на 25% от прироста (48 уд). На сколько ударов снизился? Каким стал пульс? / 25% of 48 dropped from 124.',
      helper: '25% × 48; 124 − это. / 25% then subtract.',
      answer: '−12 уд; 112 уд/мин. / −12 bpm; 112 bpm.', unit: 'уд/мин / bpm' },
    { id: 'q4', type: 'math', title: 'Health dashboard: среднее и размах / Dashboard: mean and range',
      prompt: 'Сон 8, 7.5, 8.5, 8, 7 часов. Найди среднее и размах. / Mean and range.',
      helper: 'Сумма ÷ 5; max − min. / Mean and range.',
      answer: 'Среднее 7.8 ч; размах 1.5 ч. / Mean 7.8; range 1.5.', unit: 'ч / h' },
    { id: 'q5', type: 'math', title: 'Процент привычек с округлением / Habits percent with rounding',
      prompt: 'Макс сделал 18 из 24 привычек. Какой процент? Сколько привычек нужно для 90%? / Percent and habits needed for 90%.',
      helper: '18 ÷ 24; 90% × 24 округли вверх. / Divide; then 0.9 × 24 with ceiling.',
      answer: '75%; для 90% нужно 22 привычки (21.6 → 22). / 75%; 22 habits.', unit: '%' },
    { id: 'q6', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'сердце / heart' },
        { id: 'w2', text: 'здоровый / healthy' },
        { id: 'w3', text: 'наблюдать / to observe' },
        { id: 'w4', text: 'привычка / habit' },
        { id: 'w5', text: 'спокойный / calm' },
        { id: 'w6', text: 'записать / to record' }
      ] },
    { id: 'q7', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «серце бьётса быстрея после движэния, а данные помагают понять свае тело». / Rewrite without mistakes.',
      placeholder: 'Сердце бьётся... / Heart beats...' },
    { id: 'q8', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Наблюдение за собой» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea, 3-point plan, 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q9', type: 'text', title: 'Наблюдение: пульс до и после / Observation: pulse before and after',
      prompt: 'С родителем: 1) сядь спокойно 2 минуты; 2) посчитай пульс за 30 секунд; 3) умножь на 2; 4) сделай 20 jumping jacks или 1 минуту активного движения; 5) снова посчитай пульс за 30 секунд; 6) умножь на 2; 7) сравни. Запиши: до, после, что изменилось, почему, вывод. Безопасность: только с родителем; не делать, если плохо; остановиться при головокружении. / With parent: sit 2 min, count 30-second pulse ×2, do 20 jumping jacks, count again ×2, compare. Fields: before, after, what changed, why, conclusion. Safety: parent-supervised; stop if dizzy.',
      placeholder: 'Пульс до: ____; после: ____; изменение: ...' },
    { id: 'q10', type: 'text', title: 'Логика: пульс и восстановление / Logic: pulse and recovery',
      prompt: 'Почему пульс растёт после движения и снижается после отдыха? Ответ 3–4 предложениями. / Why pulse rises and falls?',
      placeholder: 'После движения... / After movement...' },
    { id: 'q11', type: 'essay', title: 'Мой health dashboard недели / My weekly health dashboard',
      prompt: 'Заполни 5 полей за неделю: сон (ч), вода (л), активность (мин), энергия (1–10), вывод недели. Посчитай среднее сна и общее время активности. / Weekly dashboard: sleep, water, activity, energy, weekly conclusion; compute mean sleep and total activity.',
      minSentences: 4, maxSentences: 10, placeholder: 'Сон: среднее ____ ч. Вода: ____ л. Активность: ____ мин. Энергия: ____...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 6, День 5». / Heading.',
    'Слой 1. Математика: q1 (пульс), q2 (% роста), q3 (восстановление), q4 (среднее/размах сна), q5 (% привычек с округлением). / Math.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: пульс и восстановление. / Logic.',
    'Слой 5. Практика: наблюдение пульса + health dashboard. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 6, День 5 / Week 6, Day 5',
    subtitle: 'Проект недели: health dashboard и наблюдение пульса / Week Project: Health Dashboard and Pulse Observation',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: наблюдение пульса + health dashboard / Practical: pulse observation + dashboard — 20–25 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: конверсия времени, проценты роста, процент от прироста, среднее/размах, округление вверх. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) Пульс до: 38 × 2 = ____ уд/мин. Пульс после: 62 × 2 = ____ уд/мин. / bpm.',
          '2) Рост: ____ − 76 = ____ уд. Процент: ____ ÷ 76 ≈ ____%. / Growth %.',
          '3) 25% × 48 = ____ уд. Пульс стал: 124 − ____ = ____ уд/мин. / Recovery.',
          '4) Сон 8, 7.5, 8.5, 8, 7. Сумма = ____. Среднее = ____ ÷ 5 = ____ ч. Размах = 8.5 − 7 = ____ ч. / Sleep stats.',
          '5) Привычки: 18 ÷ 24 = ____ = ____%. Для 90% нужно 0.9 × 24 = ____; округли вверх до ____. / Percent + ceiling.',
          '6) Проверка / Check: 76 + 48 = ____ = пульс после? / Verify.',
          '7) Optional / Доп.: если пульс упадёт ещё на 12 уд, он станет ____ уд/мин. / Extra drop.',
          '8) Optional / Доп.: если 90% сделано, а сделал 20, полная цель = 20 ÷ 0.9 ≈ ____ (обратный %). / Inverse %.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: определяем часть речи по вопросу; исправляем безударные и −тся/−ться. / Parts of speech + −tsya.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: пульс, сердце, движение, энергия, привычка, вывод, наблюдение, восстановление.',
          'Части речи / Parts of speech: сердце, здоровый, наблюдать, привычка, спокойный, записать — раздели.',
          'Исправь ошибки / Fix mistakes: «серце бьётса быстрея после движэния, а данные помагают понять свае тело».',
          'Мини-диктант / Mini-dictation: «Сердце бьётся быстрее после движения, а данные помогают понять своё тело».',
          'Орфограмма дня / Spelling rule: −тся/−ться и жи-ши. / −tsya + ZHI-SHI.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Наблюдение за собой» / Text: Наблюдать за своим телом — не значит бояться его. Это значит спокойно смотреть на цифры: как бьётся сердце, сколько минут движения, сколько часов сна. Тело — это система, и в ней всё связано. Если Макс видит цифры, он замечает, что маленькое действие меняет большое состояние. Так наблюдение превращается в вежливое отношение к самому себе. / Observing your body does not mean fearing it. It means calmly looking at numbers: heartbeat, minutes of movement, hours of sleep. The body is a system where things connect. When Max sees numbers, he notices how a small action changes a big state. Observation becomes a polite way of treating yourself.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о наблюдении за собой / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Данные пульса до / после / после отдыха: 76 / 124 / 112. / Data: 76 / 124 / 112.' },
        { type: 'list', items: [
          'Что произошло с пульсом при движении? / What happened during movement?',
          'Что произошло с пульсом при отдыхе? / What happened during rest?',
          'Почему тело умеет возвращать пульс к покою? / Why can the body return the pulse to rest?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: сердце реагирует на нагрузку и восстанавливается после отдыха. / Heart responds and recovers.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: пульс + health dashboard / Layer 5. Practical Knowledge: Pulse + Dashboard', blocks: [
        { type: 'text', text: 'Безопасность / Safety: только с родителем; не делать при плохом самочувствии; остановиться при головокружении. Это не медицинский совет. / Parent-supervised; stop if unwell.' },
        { type: 'list', items: [
          'Наблюдение пульса / Pulse observation:',
          '1) Сядь спокойно 2 минуты. / Sit calmly for 2 minutes.',
          '2) Пульс за 30 секунд: ____ × 2 = ____ уд/мин. / 30-second count ×2.',
          '3) 20 jumping jacks или 1 минута движения. / 20 jumping jacks or 1 min movement.',
          '4) Пульс за 30 секунд: ____ × 2 = ____ уд/мин. / After.',
          '5) Что изменилось? / What changed?',
          '6) Почему, как думаешь? / Why?',
          '7) Мой вывод / Conclusion: ______',
          'Health dashboard недели / Weekly dashboard:',
          'Сон среднее / Sleep mean: ____ ч.',
          'Вода / Water: ____ л (общее за неделю или дневное среднее).',
          'Активность / Activity: ____ мин (общая за неделю).',
          'Энергия среднее / Energy mean: ____ / 10.',
          'Вывод недели / Weekly conclusion: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что новое я узнал про своё тело / What new I learned about my body: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 5 нимов / nims ✓',
          'Бонус за точный пульс и % роста / Bonus for accurate pulse and growth %: +1 ☐',
          'Бонус за понятный dashboard / Bonus for a clear dashboard: +1 ☐',
          'Бонус за спокойное наблюдение / Bonus for calm observation: +1 ☐',
          'Бонус за вывод недели / Bonus for weekly conclusion: +1 ☐',
          'Итого / Total: ____ из / of 9 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: пульс bpm, процент роста ≈ 63.2%, 25% от 48 = 12; среднее сна 7.8 ч, размах 1.5 ч; проценты привычек с округлением вверх (0.9 × 24 = 21.6 → 22). Русский Grade 3–4: части речи и исправление. Наблюдение пульса безопасно с родителем. / Grade 6 math + safe pulse observation.',
    mathGoal: 'q1: 76 и 124. q2: +48 уд, ≈ 63.2%. q3: −12 уд; стал 112. q4: среднее 7.8 ч; размах 1.5 ч. q5: 75%; для 90% нужно 22. / Listed with steps.',
    russianGoal: 'Существительные: сердце, привычка. Глаголы: наблюдать, записать. Прилагательные: здоровый, спокойный. / Correct parts of speech.',
    readingWritingGoal: 'Главная мысль: наблюдение за собой — вежливое отношение к телу. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Пульс до/после/после отдыха + health dashboard недели с выводом. / Pulse before/after + weekly dashboard with conclusion.',
    check: [
      'Q1: 76 и 124 уд/мин.',
      'Q2: +48 уд; ~63.2%.',
      'Q3: −12 уд; 112 уд/мин.',
      'Q4: 7.8 ч и 1.5 ч.',
      'Q5: 75%; для 90% — 22 привычки.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Наблюдение пульса с родителем; безопасность соблюдена. / Pulse observation done safely.',
      'Health dashboard заполнен и есть вывод недели. / Dashboard + weekly conclusion.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '38 × 2 = 76 уд/мин; 62 × 2 = 124 уд/мин. / 76 and 124 bpm.' },
      { taskId: 'q2', answer: '124 − 76 = 48 уд; 48 ÷ 76 ≈ 0.632 = 63.2%. / +48; ~63.2%.' },
      { taskId: 'q3', answer: '25% × 48 = 12 уд; 124 − 12 = 112 уд/мин. / −12; 112 bpm.' },
      { taskId: 'q4', answer: 'Сумма 8+7.5+8.5+8+7 = 39; среднее 7.8; размах 8.5 − 7 = 1.5. / Mean 7.8; range 1.5.' },
      { taskId: 'q5', answer: '18 ÷ 24 = 0.75 = 75%; 0.9 × 24 = 21.6 → округлить вверх до 22 привычек. / 75%; 22 habits.' },
      { taskId: 'q6', answer: 'Существительные: сердце, привычка. Глаголы: наблюдать, записать. Прилагательные: здоровый, спокойный.' },
      { taskId: 'q7', answer: 'Сердце бьётся быстрее после движения, а данные помогают понять своё тело.' },
      { taskId: 'q8', answer: 'Главная мысль: наблюдение — это вежливое отношение к телу. План: 1) наблюдать = не бояться; 2) тело как система; 3) малое действие меняет большое состояние. 4 предложения — открытый ответ.' },
      { taskId: 'q9', answer: 'Ожидаемое наблюдение: пульс до ниже, после выше, после отдыха снижается. Ребёнок фиксирует 2 значения и вывод. Safety соблюдена. / Before < After; After > Recovery. Safety respected.' },
      { taskId: 'q10', answer: 'После движения мышцам нужно больше кислорода, поэтому сердце бьётся чаще. После отдыха потребность падает и пульс возвращается к покою. / More O2 during work; return at rest.' },
      { taskId: 'q11', answer: 'Открытый ответ: 5 полей dashboard + среднее сна и общая активность + вывод недели. / Open answer.' }
    ],
    spellingCheck: 'Части речи + −тся/−ться правильно. / Parts of speech + −tsya rule.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Как ты почувствовал разницу пульса? / How did you feel the pulse difference?',
      'Что помогает пульсу быстрее вернуться к норме? / What helps the pulse return faster?',
      'Что ты хочешь улучшить на следующей неделе? / What do you want to improve next week?',
      'Как понять, что привычка становится устойчивой? / How to tell a habit is sticking?'
    ],
    ifEasy: 'Усложни: посчитай процент восстановления от прироста, если пульс упадёт до 88. / Extend: compute recovery % if drops to 88.',
    ifDifficult: 'Оставь q1, q4 и наблюдение пульса. / Keep q1, q4 and pulse observation.',
    rubric: [
      'Математика: 4 из 5 математических задач решены с шагами. / At least 4/5 math tasks with steps.',
      'Русский: части речи разобраны и исправление ошибок сделано. / Parts of speech + corrected sentence.',
      'Чтение: главная мысль ясна, план из 3 пунктов, 4 предложения. / Reading essentials present.',
      'Логика: 3–4 предложения про пульс и восстановление. / Logic paragraph.',
      'Наблюдение: безопасно с родителем; записаны 2 значения пульса и вывод. / Pulse observation safe.',
      'Dashboard: 5 полей + вывод недели. / Weekly dashboard complete.',
      'Награда: 5 базовых + 4 бонуса возможны (максимум 9). / 5 base + up to 4 bonuses (max 9).'
    ],
    safetyNotes: 'Только с родителем. Не проводить наблюдение при плохом самочувствии, температуре, головокружении. Остановиться, если тяжело дышать. Не отслеживать вес, давление, лекарства — это не медицинский совет. / Parent-supervised; stop if unwell; not medical advice.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 5, max: 9,
    label: 'Награда за проект недели / Week project reward', display: '5 нимов / 5 nims',
    bonuses: [
      { id: 'accurate-pulse', label: 'Бонус за точный пульс и % роста / Bonus for accurate pulse and growth %', amount: 1 },
      { id: 'clean-dashboard', label: 'Бонус за понятный dashboard / Bonus for a clear dashboard', amount: 1 },
      { id: 'calm-observation', label: 'Бонус за спокойное наблюдение / Bonus for calm observation', amount: 1 },
      { id: 'weekly-conclusion', label: 'Бонус за вывод недели / Bonus for a weekly conclusion', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q8', 'q9', 'q11'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-6', dayId: 'day-4' },
  nextLessonId: 'max-week-7-day-1'
};

export default maxWeek6Day5;
